import Kuroshiro from "kuroshiro";
import KuromojiAnalyzer from "kuroshiro-analyzer-kuromoji";
// Instantiate
const kuroshiro = new Kuroshiro();
// Initialize
// Here uses async/await, you could also use Promise
async function initKuroshiroInstance() {
  await kuroshiro.init(new KuromojiAnalyzer({ dictPath: "/dict" }));
}

// 半角文字を全角文字に変換する共通関数
function toFullWidth(text) {
  // 半角英数字や記号を全角に変換
  return text.replace(/[A-Za-z0-9!-~]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) + 0xfee0);
  });
}

// 全角カタカナのみ自動入力
async function onlyKatakana(text) {
  try {
    const katakanaAndOthers = text
      ? await kuroshiro.convert(String(text), { to: "katakana" })
      : "";
    return katakanaAndOthers.replace(/[^ァ-ンヴー　 ]/g, "");
  } catch (error) {}
}

// 全角カタカナ+全角数字のみ自動入力
async function onlyKatakanaAndFullWithNumber(text) {
  try {
    // 入力されたテキストを半角から全角に変換
    const fullWidthText = toFullWidth(String(text));
    // Kuroshiroで全角カタカナに変換
    const katakanaAndOthers = fullWidthText
      ? await kuroshiro.convert(fullWidthText, { to: "katakana" })
      : "";
    // カタカナと全角数字以外の文字を削除
    return katakanaAndOthers.replace(/[^ァ-ンヴー０-９　 ]/g, "");
  } catch (error) {}
}

// 全角カタカナ+数字+全角ロマのみ自動入力
async function onlyFullWidth(text) {
  const katakanaAndOthers = await kuroshiro.convert(text, { to: "katakana" });
  return katakanaAndOthers.replace(/[^ァ-ンヴー０-９ａ-ｚＡ-Ｚ　]/g, "");
}
export {
  initKuroshiroInstance,
  kuroshiro,
  onlyKatakana,
  onlyFullWidth,
  onlyKatakanaAndFullWithNumber,
};
